import React from "react";
import "./styles/Footer.css";
import IconByName from "./IconByName";

// Shown only when the `footerHours` field in Strapi is empty. Delete this
// constant (and the `|| DEFAULT_HOURS` below) to make the item purely
// data-driven again.
const DEFAULT_HOURS = "Mo – Fr\n07:45 – 13:30";

export default function Footer({ data = {} }) {
  const year = new Date().getFullYear();

  const kicker = data.footerKicker || "Volksschule";
  const schoolName = data.schoolName || "Rothenburgschule";

  // Address can come as one field ("Rothenburgstraße 14, 1210 Wien" or with a
  // line break) — split it into two display lines either way.
  const addressLines = (data.schoolAddress || "")
    .split(/\n|,\s*/)
    .map((s) => s.trim())
    .filter(Boolean);

  // Opening hours, e.g. "Mo – Fr\n07:45 – 13:30"
  const hoursLines = (data.footerHours || DEFAULT_HOURS)
    .split(/\n/)
    .map((s) => s.trim())
    .filter(Boolean);

  const infoItems = [
    addressLines.length
      ? { icon: "pin", lines: addressLines, key: "address" }
      : null,
    data.schoolPhone
      ? { icon: "phone", lines: [data.schoolPhone], href: `tel:${data.schoolPhone.replace(/\s+/g, "")}`, key: "phone" }
      : null,
    data.schoolEmail
      ? { icon: "mail", lines: [data.schoolEmail], href: `mailto:${data.schoolEmail}`, key: "email" }
      : null,
    hoursLines.length
      ? { icon: "clock", lines: hoursLines, key: "hours" }
      : null,
  ].filter(Boolean);

  return (
    <footer className="site-footer" aria-label="Fußbereich">
      {/* Wave is anchored to the footer's own top edge — see CSS (position:
          absolute; bottom: 100%) — so it can never show a gap underneath it. */}
      <div className="site-footer__wave" aria-hidden="true">
        <svg viewBox="0 0 1440 80" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
          <path d="
            M0,50
            C180,10 360,70 540,40
            C720,10 900,70 1080,40
            C1260,10 1380,60 1440,45
            L1440,80 L0,80 Z
          " fill="#925a64" />
        </svg>
      </div>

      <div className="container site-footer__row">
        <div className="site-footer__brand">
          <p className="site-footer__kicker">{kicker.toUpperCase()}</p>
          <h2 className="site-footer__title">{schoolName}</h2>
        </div>

        {infoItems.length ? (
          <div className="site-footer__info">
            {infoItems.map((item) => (
              <div className="site-footer__item" key={item.key}>
                <span className="site-footer__icon" aria-hidden="true">
                  <IconByName name={item.icon} size={24} />
                </span>
                {item.href ? (
                  <a className="site-footer__item-text" href={item.href}>
                    {item.lines.map((line, i) => (
                      <span key={i}>{line}</span>
                    ))}
                  </a>
                ) : (
                  <span className="site-footer__item-text">
                    {item.lines.map((line, i) => (
                      <span key={i}>{line}</span>
                    ))}
                  </span>
                )}
              </div>
            ))}
          </div>
        ) : null}

        <img
          src="/footer-stamp.png"
          alt="Stempel: Talente, die bleiben – Website von Nico Janis, ehemaliger Schüler"
          className="site-footer__stamp"
          width={128}
          height={130}
        />

        <nav className="site-footer__legal" aria-label="Rechtliche Links">
          <a href={data.imprintUrl || "/impressum"}>Impressum</a>
          <a href={data.privacyUrl || "/datenschutz"}>Datenschutz</a>
          <a href={data.accessibilityUrl || "/cookies"}>Cookies</a>
        </nav>
      </div>

      <div className="site-footer__bottom">
        <div className="container">
          <p>© {year} {kicker} {schoolName}</p>
        </div>
      </div>
    </footer>
  );
}